import { Component, OnInit } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

import { Return } from '../../../_models/returns/return';
import { TypeaheadItem } from '../../../_models/typeahead/typeahead.item';
import { ReturnReason } from '../../../_models/returns/return.reason';
import { ActivatedRoute } from '@angular/router';
import { CustomerInformationService } from '../../../_services/customer-information.service';
import { MainService } from '../../../_services/main.service';
import { SortService } from '../../../_services/sort.service';
import { AuthService } from '../../../_services/auth.service';
import { ReturnDetail } from '../../../_models/returns/return.detail';
import { DeliveryNoteItem } from '../../../_models/delivery-notes/delivery.note.item';

@Component({
  selector: 'app-product-returns-request-item',
  templateUrl: './product-returns-request-item.component.html',
  styleUrls: ['./product-returns-request-item.component.scss']
})
export class ProductReturnsRequestItemComponent implements OnInit {

  returnItem: Return;
  isBusy: boolean;

  currentItemValue: string;
  currentItem: TypeaheadItem;
  currentAmount: number;
  currentReason: ReturnReason;
  currentDescription: string;

  currentDeliveryNoteItems: DeliveryNoteItem[];
  currentDeliveryNoteNumber: number;
  currentDeliveryNoteItem: DeliveryNoteItem;

  constructor(
    private route: ActivatedRoute,
    public customerInformationService: CustomerInformationService,
    public mainService: MainService,
    public sortService: SortService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    // this.currentAmount = 1;
    // this.currentReason = this.customerInformationService.getReturnReasons()[0];
    this.resetFields();
    this.getReturnItem();
  }

  resetFields() {
    this.currentItemValue = null;
    this.currentItem = null;
    this.currentAmount = 1;
    this.currentReason = this.customerInformationService.getReturnReasons()[0];
    this.currentDescription = "";
  }

  getReturnItem() {
    this.isBusy = true;
    this.customerInformationService.getCurrentReturn().subscribe(returnItem => {
      this.isBusy = false;
      this.returnItem = returnItem;
      console.info(returnItem);
    }, error => {
      this.isBusy = false;
      if (error.status === 401) { this.customerInformationService.gotoReturns(); }
      console.error(error);
    });
  }

  getSortedItems(): ReturnDetail[] {
    if (this.returnItem) { return this.sortService.sortObject('returns-details', this.returnItem.Details); }
    return [];
  }

  searchItem() {

  }

  typeaheadItemSelected(result: TypeaheadMatch) {
    this.currentItem = result.item;
    console.info(result);
    this.getDeliveryNoteItems();
  }

  isReasonAnders() {
    return (this.currentReason && this.currentReason.ReasonId === 3);
  }

  addCurrentItem() {

    const detail = new ReturnDetail();
    detail.InternalItemNumber = this.currentItem.InternalItemNumber;
    detail.ItemNumber = this.currentItem.ItemNumber;
    detail.ItemDescription = this.currentItem.Description;
    detail.ItemGroup = this.currentItem.ItemGroup;
    detail.Amount = this.currentAmount;
    detail.Reason = this.currentReason.ReasonId;
    detail.ReasonDescription = this.currentDescription;


    if (this.currentDeliveryNoteItem) {
      detail.DeliverNoteNumber = this.currentDeliveryNoteItem.DeliveryNoteNumber;
      detail.GrossPrice = this.currentDeliveryNoteItem.GrossPrice;
      detail.NetPrice = this.currentDeliveryNoteItem.NetPrice;
      detail.PriceUnit = this.currentDeliveryNoteItem.PriceUnit;
      detail.TotalAmount = this.currentDeliveryNoteItem.TotalAmount;
      detail.AmountOnDeliveryNote = this.currentDeliveryNoteItem.ItemCount;
    }

    this.customerInformationService.postReturnDetail(this.returnItem.Header.ReturnId, detail).subscribe(result => {
      // this.resetFields();
      // this.getReturnItem();
      this.customerInformationService.gotoReturnRequest();
    }, error => {
      console.info(error);
    });
  }

  compareReason(c1: ReturnReason, c2: ReturnReason): boolean {
    return c1 && c2 ? c1.ReasonId === c2.ReasonId : c1 === c2;
  }

  deleteItem(item: ReturnDetail) {
    this.mainService.confirmBox("Wilt u dit artikel verwijderen?").subscribe(result => {
      if (result) {
        this.customerInformationService.deleteReturnDetail(this.returnItem.Header.ReturnId, item).subscribe(result => {
          this.resetFields();
          this.getReturnItem();
        }, error => {
          console.info(error);
        });
      }
    });
  }

  send() {

    this.customerInformationService.saveReturn(this.returnItem.Header).subscribe(result => {

      this.customerInformationService.sendReturn(this.returnItem.Header.ReturnId).subscribe(result => {
        this.mainService.msgBox("Verstuurd", `Retour is verstuurd. Het ordernummer is ${result.OrderNumber}`).subscribe(resultBox => {
          this.customerInformationService.gotoReturns();
        });
      }, error => {
        console.error(error);
      });

    }, error => {
      console.error(error);
    });
  }

  save() {
    this.customerInformationService.saveReturn(this.returnItem.Header).subscribe(result => {
      this.mainService.msgBox("Opgeslagen", `De retourgegevens zijn opgeslagen!`).subscribe(resultBox => {
        this.customerInformationService.gotoReturns();
      });
    }, error => {
      console.error(error);
    });

  }

  getDeliveryNoteItems() {

    this.customerInformationService.getDeliveryNoteItems(this.currentItem.InternalItemNumber, this.currentAmount).subscribe(result => {
      this.currentDeliveryNoteItems = result;
    }, error => {
      console.error(error);
    });


  }

  addItem() {
    this.customerInformationService.gotoReturnRequestItem();
  }

  hasDeliveryNoteItems(): boolean {
    if (!this.currentDeliveryNoteItems) { return false; }
    return this.currentDeliveryNoteItems.length > 0;
  }
}
